import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { WidgetContext } from '@frontend/sports/types/components/widget';
import { DsPill } from '@frontend/ui/pill';

import { TabBarItem } from '../../tab-bar/tab-bar.models';

export enum WidgetPillDisplay {
    Default,
    Icon,
    Logo,
}

export interface WidgetPillItem extends TabBarItem<string> {
    display: WidgetPillDisplay;
    context: Partial<WidgetContext>;
    itemId: string | number;
    sportId?: number;
    widgetId: string;
}

@Component({
    selector: 'ms-widget-pill',
    templateUrl: './widget-pill.component.html',
    styleUrls: ['./widget-pill.component.scss'],
    standalone: true,
    imports: [DsPill, ScrollAdapterComponent, CompetitionLogoComponent, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetPillComponent {
    @Input() pills: WidgetPillItem[];
    @Output() select = new EventEmitter<WidgetPillItem>();
    display = WidgetPillDisplay;

    constructor(private cdr: ChangeDetectorRef) {}

    eventSelected(widgetTabBarItem: WidgetPillItem): void {
        this.pills.forEach((item) => {
            item.active = item.title === widgetTabBarItem.title;
        });
        const tabItem = this.pills.find((e) => e.id === widgetTabBarItem.id);
        this.cdr.markForCheck();
        this.select.emit(tabItem);
    }
}
